// import { startTracking, stopTracking } from '@/helpers/location';
import { startTracking, stopTracking } from '@/helpers/location-test';

export default {
  namespaced: true,
  
  state: () => ({
    latitude: null,
    longitude: null,
    isPrecise: false,
    watchId: null,
    isEnabled: false
  }),

  mutations: {
    SET_COORDINATES(state, { latitude, longitude, isPrecise }) {
      state.latitude = latitude;
      state.longitude = longitude;
      state.isPrecise = isPrecise;
    },
    SET_WATCH_ID(state, id) {
      state.watchId = id;
    },
    SET_ENABLED(state, status) {
      state.isEnabled = status;
    },
    CLEAR_LOCATION(state) {
      state.latitude = null;
      state.longitude = null;
      state.isPrecise = false;
      state.watchId = null;
    }
  },

  actions: {
    // Включение отслеживания
    // enableTracking({ commit, dispatch, state }) {
    //   // Если уже отслеживаем, сначала сбрасываем старый watch
    //   if (state.watchId) dispatch('disableTracking');

    //   commit('SET_ENABLED', true);

    //   const watchId = startTracking(
    //     (coords) => {
    //       commit('SET_COORDINATES', coords);
    //     },
    //     (error) => {
    //       console.error('Ошибка трекинга:', error);
    //       // Если пользователь запретил доступ посреди сессии
    //       dispatch('disableTracking');
    //     }
    //   );

    //   commit('SET_WATCH_ID', watchId);
    // },

    enableTracking({ commit, dispatch, state }) {
      if (state.watchId) dispatch('disableTracking');

      commit('SET_ENABLED', true);

      // Возвращаем Promise наружу, чтобы компонент мог поймать ошибку через try/catch
      return new Promise((resolve, reject) => {
        const watchId = startTracking(
          (coords) => {
            commit('SET_COORDINATES', coords);
            resolve(); // Успешно получили первые координаты
          },
          (error) => {
            console.error('Ошибка трекинга:', error);
            dispatch('disableTracking');
            reject(error); // Передаем ошибку в компонент
          }
        );

        commit('SET_WATCH_ID', watchId);
      });
    },

    // Выключение отслеживания
    disableTracking({ commit, state }) {
      if (state.watchId) {
        stopTracking(state.watchId);
      }
      commit('SET_ENABLED', false);
      commit('CLEAR_LOCATION');
    }
  }
};